import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { BrandingProvider } from "@/context/BrandingContext";
import { RegionalProvider } from "@/context/RegionalContext";
import { A11yProvider } from "@/context/A11yContext";
import { ProtectedRoute } from "@/components/bi/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Login from "@/pages/Login";
import Signup from "@/pages/Signup";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboards from "@/pages/Dashboards";
import DataSources from "@/pages/DataSources";
import DatasetExplorer from "@/pages/DatasetExplorer";
import Builder from "@/pages/Builder";
import Viewer from "@/pages/Viewer";
import Settings from "@/pages/Settings";
import Team from "@/pages/Team";
import Admin from "@/pages/Admin";
import ModelStudio from "@/pages/ModelStudio";
import PrepStudio from "@/pages/PrepStudio";
import Metrics from "@/pages/Metrics";
import Alerts from "@/pages/Alerts";
import Tv from "@/pages/Tv";
import ThemePreview from "@/pages/ThemePreview";
import Help from "@/pages/Help";
import Reports from "@/pages/Reports";
import ReportDesigner from "@/pages/ReportDesigner";
import ReportViewer from "@/pages/ReportViewer";
import ApiDocs from "@/pages/ApiDocs";
import SiteHome from "@/pages/SiteHome";
import TenantHome from "@/pages/TenantHome";
import EazyConsole from "@/pages/EazyConsole";
import SuperAdminApp from "@/superadmin/SuperAdminApp";
import { SessionResetBanner } from "@/components/bi/SessionResetBanner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrandingProvider>
        <RegionalProvider>
        <A11yProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/view/:token" element={<Viewer />} />
            <Route path="/report/:token" element={<ReportViewer />} />
            <Route path="/theme-preview" element={<ThemePreview />} />
            <Route path="/help" element={<ProtectedRoute><Help /></ProtectedRoute>} />
            <Route path="/embed/:token" element={<Viewer embed />} />
            <Route path="/" element={<ProtectedRoute><Dashboards /></ProtectedRoute>} />
            <Route path="/data" element={<ProtectedRoute><DataSources /></ProtectedRoute>} />
            <Route path="/explore" element={<ProtectedRoute><DatasetExplorer /></ProtectedRoute>} />
            <Route path="/explore/:id" element={<ProtectedRoute><DatasetExplorer /></ProtectedRoute>} />
            <Route path="/model/:id" element={<ProtectedRoute><ModelStudio /></ProtectedRoute>} />
            <Route path="/prep/:id" element={<ProtectedRoute><PrepStudio /></ProtectedRoute>} />
            <Route path="/metrics" element={<ProtectedRoute><Metrics /></ProtectedRoute>} />
            <Route path="/builder/:id" element={<ProtectedRoute><Builder /></ProtectedRoute>} />
            <Route path="/team" element={<ProtectedRoute><Team /></ProtectedRoute>} />
            <Route path="/alerts" element={<ProtectedRoute><Alerts /></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
            <Route path="/reports/:id" element={<ProtectedRoute><ReportDesigner /></ProtectedRoute>} />
            <Route path="/tv" element={<ProtectedRoute><Tv /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
            <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
            <Route path="/developer" element={<ProtectedRoute><ApiDocs /></ProtectedRoute>} />
            <Route path="/sites/:siteId" element={<ProtectedRoute><SiteHome /></ProtectedRoute>} />
            <Route path="/home" element={<ProtectedRoute><TenantHome /></ProtectedRoute>} />
            <Route path="/eazy" element={<ProtectedRoute><EazyConsole /></ProtectedRoute>} />
            <Route path="/superadmin/*" element={<SuperAdminApp />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
        <SessionResetBanner />
        </A11yProvider>
        </RegionalProvider>
        </BrandingProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
